import { useSelector } from 'react-redux';
import DayPicker from './DayPicker';
import TimePicker from './TimePicker';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import RegularText from '@/components/RegularText';
import { shippingSettingSelector } from '@/redux/slice/shipping.slice';
import { previewOptionSelector } from '@/redux/slice/preview.slice';
import { SETTING_TYPE } from '@/constants/enum';

const DateTimeContainer = () => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const shippingSettings = useSelector(shippingSettingSelector);
  const previewOptions = useSelector(previewOptionSelector);

  const isShippingMethodSelected = previewOptions.methods.find((item) => item.selected)?.key === SETTING_TYPE.SHIPPING;
  return (
    <>
      {!shippingSettings?.isActiveDatePicker && isShippingMethodSelected ? null : <DayPicker />}
      {widgetSettings.customMessage && <RegularText>{widgetSettings.customMessage}</RegularText>}
      <TimePicker />
    </>
  );
};

export default DateTimeContainer;
